import type { HelpWidgetMessage } from "../types/help_widget_message";

export const shouldShowFadingTextEffect = (msg: HelpWidgetMessage): boolean =>
  msg.channel === "circle_bot" && msg.author_type === "bot";

export const appendMessageWithFadingEffect = (
  prevMessages: HelpWidgetMessage[],
  msg: HelpWidgetMessage,
): HelpWidgetMessage[] => {
  const updated = prevMessages.map(prevMessage => ({
    ...prevMessage,
    show_fading_text_effect: false,
  }));
  return [
    ...updated,
    {
      ...msg,
      show_fading_text_effect: shouldShowFadingTextEffect(msg),
    },
  ];
};
